<template>
    <div v-if="consumer" class="consumers-info">
        <h1 class="consumersInfo-title">Nome: {{ consumer.name }}</h1>
        <img :src="consumer.logoUrl" v-if="consumer.logoUrl" />

        <br>
        <button :disabled="resendDisabled" type="submit" @click="resendEmail">Enviar email de convite</button>

        <h2>Utilizadores Registados</h2>
        <TableComponent :columns="userCols" :elements="users" :destination="(user) => '/'">
        </TableComponent>

        <template v-if="assigned.length">
            <h2>Em curso</h2>
            <TableComponent :columns="columns" :elements="assigned"
                :destination="(project) => ({ name: 'ProjectMessages', params: { id: project.id } })">
            </TableComponent>
        </template>

        <template v-if="unassigned.length">
            <h2>Novos</h2>
            <TableComponent :columns="columns" :elements="unassigned"
                :destination="(project) => ({ name: 'ProjectMessages', params: { id: project.id } })">
            </TableComponent>
        </template>

        <template v-if="done.length">
            <h2>Concluídos</h2>
            <TableComponent :columns="columns" :elements="done"
                :destination="(project) => ({ name: 'ProjectMessages', params: { id: project.id } })">
            </TableComponent>
        </template>
    </div>
</template>

<script>
import TableComponent from '@/components/Table.vue'
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "@/firebaseApp";

const functions = getFunctions(app);
const sendInvite = httpsCallable(functions, 'consumers-onCall-sendInvite')

export default {
    name: 'ConsumersInfo',
    props: {
        id: {
            required: true
        },
    },
    components: {
        TableComponent,
    },
    data() {
        return {
            columns: [
                { text: this.$t('user'), attribute: 'consumerName' },
                { text: this.$t('name'), attribute: 'name' },
                { text: this.$t('service'), attribute: 'serviceName' },
            ],
            userCols: [
                { text: this.$t('name'), attribute: 'name' },
                { text: this.$t('email'), attribute: 'email' },
            ],
            isAssignedSection: false,
        }
    },
    methods: {
        async resendEmail() {
            await sendInvite({
                consumerId: this.consumer.id,
                instanceId: this.instanceId,
            });
        }
    },
    computed: {
        assigned() {
            return this.projects.filter(({ done, worker }) => !done && worker != null)
        },
        consumer() {
            return this.$store.getters['consumers/id'](this.id)
        },
        currentUser() {
            return this.$store.state.users.currentUser
        },
        done() {
            return this.projects.filter(({ done }) => done)
        },
        instanceId() {
            return this.$store.state.instanceId
        },
        projects() {
            return this.$store.getters['projects/consumer'](this.id);
        },
        resendDisabled() {
            if (this.consumer?.inviteSentAt == null) {
                return false
            }
            let inviteSentAt = this.consumer.inviteSentAt
            const sentDate = new Date(
                inviteSentAt.seconds * 1000
            ).getTime()
            const sentAgo = Date.now() - sentDate
            const day = 86400000
            return sentAgo < day
        },
        users() {
            return this.$store.getters['users/consumer'](this.id);
        },
        unassigned() {
            return this.projects.filter(({ done, worker }) => !done && worker == null)
        },
    },
    async mounted() { }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.consumers-info {
    img {
        max-width: min(100%, 400px);
    }

    button {
        margin: auto;
        height: 3rem;
        padding: 0 1rem;
        background-color: var(--highlight-color);
        color: var(--white);
        font-weight: bold;
        font-size: 1rem;
        border: none;
        text-transform: uppercase;
        border-radius: 5px;

        &:not(:disabled) {
            cursor: pointer;
        }

        &:disabled {
            background-color: var(--bg-color-1);
            opacity: .5;
        }

        &:active {
            transform: scale(.95);
        }
    }
}
</style>
